// import React, { useState } from "react";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";
// import './Admin.scss';
// import logo from '../assets/images/logo.png';
// import imageplot from '../assets/images/loginimage.jpg';
// import { FaEyeSlash } from "react-icons/fa6";
// import { FaEye } from "react-icons/fa";
// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState({});
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const validate = () => {
//     let tempErrors = {};
//     let isValid = true;
//     if (!email) {
//       tempErrors.email = "Email is required";
//       isValid = false;
//     } else if (!/\S+@\S+\.\S+/.test(email)) {
//       tempErrors.email = "Email is invalid";
//       isValid = false;
//     }
//     if (!password) {
//       tempErrors.password = "Password is required";
//       isValid = false;
//     } else if (password.length < 6) {
//       tempErrors.password = "Password must be at least 6 characters";
//       isValid = false;
//     }
//     setError(tempErrors);
//     return isValid;
//   };


//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (!validate()) {
//       return;
//     }
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, password }),
//       });
//       const data = await response.json();
//       if (response.ok && data.success === "1") {
//         localStorage.setItem("isLoggedIn", "true");
//         localStorage.setItem("userEmail", email);
//         if (data.token) {
//           localStorage.setItem("token", data.token);
//         }

//         Swal.fire({
//           title: "<strong>Login Successful!</strong>",
//           html: `<p style="margin-top: 10px;">Welcome, ${email}</p>`,
//           icon: "success",
//           timer: 1500,
//           timerProgressBar: true,
//           showConfirmButton: false,
//           allowOutsideClick: false,
//           width: "22em",
//           customClass: {
//             popup: "custom-swal",
//             title: "custom-swal-title",
//             icon: "custom-swal-icon",
//           },
//           didClose: () => {
//             //navigate("/dashboard");
//           //window.location.href = "/homedashboard";
//             window.location.href = "/dashboard";
//           },
//         });

//         setError({});
//       } else {
//         setError({ form: data.message || "Invalid email or password." });
//       }
//     } catch (err) {
//       setError((prevError) => ({
//         ...prevError,
//         password: "Invalid Password",
//       }));
//       console.error("Login error:", err);
//     }
//   };

//   return (
//     <div>
//       <div className="adminlogin">
//         <div className="d-flex login_form align-items-center">
          
//           <div className="login-wrapper">
//             <div className="form_design">
//               <div className="logo_login">
//                 <img src={logo} alt="logo" />
//               </div>
//               <h2>Welcome Back admin</h2>
//               <p>Let’s login to grab amazing deal</p>
//               {error.form && (
//                 <div className="alert alert-danger">{error.form}</div>
//               )}
//               <form onSubmit={handleLogin} noValidate className="login-form text-start">
//                 <div className="form-group">
//                   <label htmlFor="email">Email address</label>
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     className={` h-56-px ${error.email ? "error-input" : ""
//                       }`}
//                     placeholder="Enter your email"
//                   />
//                   {error.email && (
//                     <span className="error-text" style={{ color: "red" }}>
//                       {error.email}
//                     </span>
//                   )}
//                 </div>
//                 <div className="form-group">
//                   <label htmlFor="">Password</label>
//                   <div style={{ position: "relative" }}>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className={` h-56-px ${error.password ? "error-input" : ""
//                         }`}
//                       name="password"
//                       id="password"
//                       value={password}
//                       onChange={(e) => setPassword(e.target.value)}
//                       placeholder="Enter your password"
//                       style={{ paddingRight: "40px" }}
//                     />
//                     <span
//                       className="eye-icon"
//                       onClick={() => setShowPassword(!showPassword)}
//                       role="button"
//                       tabIndex={0}
//                       onKeyPress={(e) => {
//                         if (e.key === "Enter") setShowPassword(!showPassword);
//                       }}
//                       style={{
//                         position: "absolute",
//                         right: "12px",
//                         top: "50%",
//                         transform: "translateY(-50%)",
//                         cursor: "pointer",
//                         userSelect: "none",
//                         fontSize: "18px",
//                         color: "#555",
//                       }}
//                     >
//                       {showPassword ? <FaEyeSlash /> : <FaEye />}
//                     </span>
//                   </div>
//                   {error.password && (
//                     <span className="error-text" style={{ color: "red" }}>
//                       {error.password}
//                     </span>
//                   )}

//             </div>

           

//           <div className="form-options">
//           <label>
//             <input type="checkbox" defaultChecked /> Remember me
//           </label>
//         </div>


//             <button className="login-btn" type="submit">Login</button>
//           </form>

          
//         </div>
//       </div>
//     </div>
//       </div >
  
//     </div >
//   );
// };
// export default Login;

import React, { useState } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import "./Admin.scss";
import logo from "../assets/images/logo.png";
import {
  FaEnvelope,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
} from "react-icons/fa";

const Login = () => {
  // const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [error, setError] = useState({});
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("a2demoadmin@gmail.com");
const [password, setPassword] = useState("123456");

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!email) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      tempErrors.email = "Email is invalid";
      isValid = false;
    }
    if (!password) {
      tempErrors.password = "Password is required";
      isValid = false;
    } else if (password.length < 6) {
      tempErrors.password = "Password must be at least 6 characters";
      isValid = false;
    }
    setError(tempErrors);
    return isValid;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password }),
        }
      );
      const data = await response.json();

      if (response.ok && data.success === "1") {
        localStorage.setItem("isLoggedIn", "true");
        localStorage.setItem("userEmail", email);
        if (data.token) {
          localStorage.setItem("token", data.token);
        }

        Swal.fire({
          title: "<strong>Login Successful!</strong>",
          html: `<p style="margin-top: 10px;">Welcome, ${email}</p>`,
          icon: "success",
          timer: 1500,
          timerProgressBar: true,
          showConfirmButton: false,
          allowOutsideClick: false,
          width: "22em",
          didClose: () => {
            window.location.href = "/dashboard";
          },
        });

        setError({});
      } else {
        setError({ form: data.message || "Invalid email or password." });
      }
    } catch (err) {
      console.error("Login error:", err);
      setError({ form: "Something went wrong. Try again later." });
    }
  };

  /* ═══════════ FORGOT PASSWORD ALERT ═══════════ */
  const handleForgotPassword = (e) => {
    e.preventDefault();
    Swal.fire({
      title: '<span style="color: #0d1b4c; font-weight: 800;">Forgot Password?</span>',
      html: `
        <div style="padding: 10px 0; font-family: 'Poppins', sans-serif;">
          <div style="width: 70px; height: 70px; margin: 0 auto 16px; background: linear-gradient(135deg, #e63946, #c1121f); border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 10px 25px rgba(230, 57, 70, 0.35);">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <p style="font-size: 15px; color: #475569; line-height: 1.6; margin: 0 0 8px; font-weight: 500;">
            For security reasons, please contact our <strong style="color:#e63946;">Super Admin</strong> to reset your password.
          </p>
        </div>
      `,
      showConfirmButton: true,
      confirmButtonText: "Got it",
      confirmButtonColor: "#e63946",
      width: "380px",
      padding: "28px 24px",
    });
  };

  return (
    <div className="login-page">
      {/* ═══════════ LEFT: DARK PANEL ═══════════ */}
      <div className="login-left">
        <div className="login-left-overlay"></div>
        <div className="login-left-content">
          <div className="login-brand">
            <img src={logo} alt="A2 Demo" />
          </div>
          <h1>
            Welcome to <span>Admin Panel</span>
          </h1>
          <p>Your Trusted Partner in Real Estate</p>
          <ul className="login-features">
            <li>✓ Verified Properties</li>
            <li>✓ RERA Approved Projects</li>
            <li>✓ Trusted by 1000+ Associates</li>
          </ul>
        </div>
      </div>

      {/* ═══════════ RIGHT: LOGIN FORM ═══════════ */}
      <div className="login-right">
        <div className="login-form-wrapper">
          <div className="login-header">
            <h2>
              Admin <span>Login</span>
            </h2>
            <p>Login to access your dashboard</p>
          </div>

          {error.form && <p className="login-error-form">{error.form}</p>}

          <form onSubmit={handleLogin} className="login-form" noValidate>
            {/* Email */}
            <div className="login-input-group">
              <label>Email Address</label>
              <div className="login-input-wrapper">
                <FaEnvelope className="login-input-icon" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Your Email"
                  className={error.email ? "error-input" : ""}
                />
              </div>
              {error.email && (
                <small className="login-error">{error.email}</small>
              )}
            </div>

            {/* Password */}
            <div className="login-input-group">
              <label>Password</label>
              <div className="login-input-wrapper">
                <FaLock className="login-input-icon" />
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter Your Password"
                  className={error.password ? "error-input" : ""}
                />
                <button
                  type="button"
                  className="login-toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {error.password && (
                <small className="login-error">{error.password}</small>
              )}
            </div>

            {/* Options */}
            <div className="login-options">
              <label className="login-remember">
                {/* <input type="checkbox" defaultChecked /> Remember me */}
                <input type="checkbox" defaultChecked /> Remember me
              </label>
              <button
                type="button"
                className="login-forgot"
                onClick={handleForgotPassword}
              >
                Forgot Password?
              </button>
            </div>

            {/* Submit */}
            <button type="submit" className="login-btn-submit">
              Login <FaArrowRight />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
